import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import moment from 'moment';

export default [
  {
    name: 'start',
    label: i18n('entities.dailyReport.fields.start'),
    schema: schemas.date(
      i18n('entities.dailyReport.fields.start'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YYYY-MM-DD') : value,
  },
  {
    name: 'end',
    label: i18n('entities.dailyReport.fields.end'),
    schema: schemas.date(
      i18n('entities.dailyReport.fields.end'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YYYY-MM-DD') : value,
  },
  {
    name: 'businessId',
    label: i18n('entities.dailyReport.fields.businessId'),
    schema: schemas.string(
      i18n('entities.dailyReport.fields.businessId'),
      {},
    ),
  },
  {
    name: 'date',
    label: i18n('entities.dailyReport.fields.date'),
    schema: schemas.datetime(
      i18n('entities.dailyReport.fields.date'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YYYY-MM-DD HH:mm') : value,
  },
  {
    name: 'totalPageViews',
    label: i18n('entities.dailyReport.fields.totalPageViews'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.totalPageViews'),
      {},
    ),
  },
  {
    name: 'calls',
    label: i18n('entities.dailyReport.fields.calls'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.calls'),
      {},
    ),
  },
  {
    name: 'mapViews',
    label: i18n('entities.dailyReport.fields.mapViews'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.mapViews'),
      {},
    ),
  },
  {
    name: 'uRLClicks',
    label: i18n('entities.dailyReport.fields.uRLClicks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.uRLClicks'),
      {},
    ),
  },
  {
    name: 'checkIns',
    label: i18n('entities.dailyReport.fields.checkIns'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.checkIns'),
      {},
    ),
  },
  {
    name: 'bookmarks',
    label: i18n('entities.dailyReport.fields.bookmarks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.bookmarks'),
      {},
    ),
  },
  {
    name: 'desktopCTAClicks',
    label: i18n('entities.dailyReport.fields.desktopCTAClicks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.desktopCTAClicks'),
      {},
    ),
  },
  {
    name: 'mobileCTAClicks',
    label: i18n('entities.dailyReport.fields.mobileCTAClicks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.mobileCTAClicks'),
      {},
    ),
  },
  {
    name: 'messagesToBusiness',
    label: i18n('entities.dailyReport.fields.messagesToBusiness'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.messagesToBusiness'),
      {},
    ),
  },
  {
    name: 'desktopSearchAppearances',
    label: i18n('entities.dailyReport.fields.desktopSearchAppearances'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.desktopSearchAppearances'),
      {},
    ),
  },
  {
    name: 'mobileSearchAppearances',
    label: i18n('entities.dailyReport.fields.mobileSearchAppearances'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.mobileSearchAppearances'),
      {},
    ),
  },
  {
    name: 'trackingCalls',
    label: i18n('entities.dailyReport.fields.trackingCalls'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.trackingCalls'),
      {},
    ),
  },
  {
    name: 'dealsSold',
    label: i18n('entities.dailyReport.fields.dealsSold'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.dealsSold'),
      {},
    ),
  },
  {
    name: 'onlineOrders',
    label: i18n('entities.dailyReport.fields.onlineOrders'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.onlineOrders'),
      {},
    ),
  },
  {
    name: 'onlineBookings',
    label: i18n('entities.dailyReport.fields.onlineBookings'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.onlineBookings'),
      {},
    ),
  },
  {
    name: 'billedImpressions',
    label: i18n('entities.dailyReport.fields.billedImpressions'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.billedImpressions'),
      {},
    ),
  },
  {
    name: 'billedClicks',
    label: i18n('entities.dailyReport.fields.billedClicks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.billedClicks'),
      {},
    ),
  },
  {
    name: 'adCost',
    label: i18n('entities.dailyReport.fields.adCost'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adCost'),
      {},
    ),
  },
  {
    name: 'adDrivenCalls',
    label: i18n('entities.dailyReport.fields.adDrivenCalls'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenCalls'),
      {},
    ),
  },
  {
    name: 'adDrivenCTAClicks',
    label: i18n('entities.dailyReport.fields.adDrivenCTAClicks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenCTAClicks'),
      {},
    ),
  },
  {
    name: 'adDrivenCheckIns',
    label: i18n('entities.dailyReport.fields.adDrivenCheckIns'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenCheckIns'),
      {},
    ),
  },
  {
    name: 'adDrivenDealsSold',
    label: i18n('entities.dailyReport.fields.adDrivenDealsSold'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenDealsSold'),
      {},
    ),
  },
  {
    name: 'adDrivenMapViews',
    label: i18n('entities.dailyReport.fields.adDrivenMapViews'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenMapViews'),
      {},
    ),
  },
  {
    name: 'adDrivenMessages',
    label: i18n('entities.dailyReport.fields.adDrivenMessages'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenMessages'),
      {},
    ),
  },
  {
    name: 'adDrivenUserPhotos',
    label: i18n('entities.dailyReport.fields.adDrivenUserPhotos'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenUserPhotos'),
      {},
    ),
  },
  {
    name: 'adDrivenReservations',
    label: i18n('entities.dailyReport.fields.adDrivenReservations'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenReservations'),
      {},
    ),
  },
  {
    name: 'adDrivenUrlClicks',
    label: i18n('entities.dailyReport.fields.adDrivenUrlClicks'),
    schema: schemas.integer(
      i18n('entities.dailyReport.fields.adDrivenUrlClicks'),
      {},
    ),
  },
];